// export enum InputFunction
// {
//     Unmapped,

import { IOSetup, OutputFunction } from "./api";
import { ITimeout, Timeout } from "./Context/Timeout";
import { ResourceIdentifier } from "./ResourceManager/ResourceIdentifier";

//     ButtonPayout,
//     ButtonSpin,
//     ButtonAutoplay,
//     ButtonMaxBet,
//     ButtonGamesMenu,
//     ButtonCallAttendant,
//     ButtonHelp,
//     ButtonBet1,
//     ButtonBet2,
//     ButtonBet3,
//     ButtonBet4,
//     ButtonBet5,
//     ButtonBetUp,
//     ButtonBetDown,
//     ButtonBetNext,

//     DoorSlot,
//     DoorDrop,
//     DoorCardCage,
//     DoorCashbox,
//     DoorBelly,

//     LockAttendant,
//     LockOperator,
// }

export const Button = {
    ButtonPayout: "ButtonPayout",
    ButtonSpin: "ButtonSpin",
    ButtonAutoplay: "ButtonAutoplay",
    ButtonMaxBet: "ButtonMaxBet",
    ButtonGamesMenu: "ButtonGamesMenu",
    ButtonCallAttendant: "ButtonCallAttendant",
    ButtonHelp: "ButtonHelp",
    ButtonBet1: "ButtonBet1",
    ButtonBet2: "ButtonBet2",
    ButtonBet3: "ButtonBet3",
    ButtonBet4: "ButtonBet4",
    ButtonBet5: "ButtonBet5",
    ButtonBetUp: "ButtonBetUp",
    ButtonBetDown: "ButtonBetDown",
    ButtonBetNext: "ButtonBetNext",
    ButtonLinesNext: "ButtonLinesNext",
    ButtonDoubleUp: "ButtonDoubleUp",
    ButtonDoubleUpRed: "ButtonDoubleUpRed",
    ButtonDoubleUpBlack: "ButtonDoubleUpBlack",
    ButtonDoubleUpCollectHalf: "ButtonDoubleUpCollectHalf",
    ButtonDoubleUpCollectAll: "ButtonDoubleUpCollectAll",
    ButtonVolumeNext: "ButtonVolumeNext",
    ButtonDenomMenu: "ButtonDenomMenu",
    ButtonCreditsMoney: "ButtonCreditsMoney",
    ButtonSettings: "ButtonSettings",
    ButtonChangeBetType : "ButtonChangeBetType"
} as const;

export type Button = typeof Button[keyof typeof Button];

export const Door = {
    DoorSlot: "DoorSlot",
    DoorDrop: "DoorDrop",
    DoorCardCage: "DoorCardCage",
    DoorCashbox: "DoorCashbox",
    DoorBelly: "DoorBelly",
} as const;

export const Lock = {
    LockAttendant: "LockAttendant",
    LockOperator: "LockOperator",
} as const;

export const InputFunction = {
    Unmapped: "Unmapped",

    ...Button,
    ...Door,
    ...Lock
} as const;

export type InputFunction = typeof InputFunction[keyof typeof InputFunction];

export enum InputType
{
    Unmapped = "Unmapped",
    Button = "Button",
    Door = "Door",
    Lock = "Lock"
}

export enum InputPolarity
{
    Normal = "Normal",
    Reversed = "Reversed",
}

export enum InputState
{
    RisingEdge = "RisingEdge",
    High = "High",
    FallingEdge = "FallingEdge",
    Low = "Low",
}


export const ButtonLights =
{
    LightButtonPayout: "LightButtonPayout",
    LightButtonSpin: "LightButtonSpin",
    LightButtonAutoplay: "LightButtonAutoplay",
    LightButtonMaxBet: "LightButtonMaxBet",
    LightButtonGamesMenu: "LightButtonGamesMenu",
    LightButtonCallAttendant: "LightButtonCallAttendant",
    LightButtonHelp: "LightButtonHelp",
    LightButtonBet1: "LightButtonBet1",
    LightButtonBet2: "LightButtonBet2",
    LightButtonBet3: "LightButtonBet3",
    LightButtonBet4: "LightButtonBet4",
    LightButtonBet5: "LightButtonBet5",
    LightButtonBetUp: "LightButtonBetUp",
    LightButtonDoubleUp: "LightButtonDoubleUp",
    LightButtonBetDown: "LightButtonBetDown",
    LightButtonLinesNext: "LightButtonLinesNext",
    LightButtonDoubleUpRed: "LightButtonDoubleUpRed",
    LightButtonDoubleUpBlack: "LightButtonDoubleUpBlack",
    LightButtonDoubleUpCollectHalf: "LightButtonDoubleUpCollectHalf",
    LightButtonDoubleUpCollectAll: "LightButtonDoubleUpCollectAll",
    LightButtonCreditsMoney: "LightButtonCreditsMoney",
}

export type ButtonLight = typeof ButtonLights[keyof typeof ButtonLights];

export const OtherLight = 
{
    LightCallAttendant: "LightCallAttendant",
}

export type OtherLight = typeof OtherLight[keyof typeof OtherLight];

export const Light = {
    ...ButtonLights,
    ...OtherLight
};

export type Light = typeof Light[keyof typeof Light];

// export const OutputFunction = {
//     Unmapped: "Unmapped",

//     ...ButtonLight,
//     ...OtherLight,
// } as const;

// export type OutputFunction = typeof OutputFunction[keyof typeof OutputFunction];

export enum OutputState
{
    Off = "Off",
    On = "On",
    Blinking1 = "Blinking1",
    Blinking2 = "Blinking2",
}

export enum OutputType
{
    Unmapped = "Unmapped",
    LightButton = "LightButton",
    LightOther = "LightOther",
}

export enum OutputPolarity
{
    Normal = "Normal",
    Reversed = "Reversed",
}

export interface InputMap
{
    Pin: number;
    Func: InputFunction;
    Type: InputType;
    Polarity: InputPolarity;
    DebounceMillis: number;
}

export interface OutputMap
{
    Pin: number;
    Func: OutputFunction;
    Type: OutputType;
    Polarity: OutputPolarity;
}

export interface IOMapping
{
    Name: string;
    InputMap: InputMap[];
    OutputMap: OutputMap[];
}

export interface IOBoardParams
{
    Name: string;
    Platform: string;
    FirmwareVersion: string;
    SerialNumber: string;
    NumInputs: number;
    NumOutputs: number;
}

// export interface IOSetup
// {
//     IOMapping: IOMapping;
//     BoardParams: IOBoardParams;
// }

export type ButtonChangedHandler = (button: Button, pressed: boolean) => void;
export type LightChangeHandler = (outputStates: OutputState[]) => void;

export type InputsChangedHandler = (inputStates: InputState[]) => void;
export type OutputsChangedHandler = (outputStates: OutputState[]) => void;


export interface OutputWithState
{
    light: Light;
    state: OutputState;
}


export interface ButtonState
{
    button: Button;
    enabled: boolean;
    light?: OutputState;
}

export interface SetButtonState
{
    button: Button;
    enabled: boolean;
    light?: OutputState;
}


interface ButtonLightMap
{
    button: Button;
    light: Light;
}
















const buttonLightMap: Map<Button, ButtonLight> = new Map<Button, ButtonLight>([
    [Button.ButtonPayout,        ButtonLights.LightButtonPayout],
    [Button.ButtonSpin,          ButtonLights.LightButtonSpin],
    [Button.ButtonAutoplay,      ButtonLights.LightButtonAutoplay],
    [Button.ButtonMaxBet,        ButtonLights.LightButtonMaxBet],
    [Button.ButtonGamesMenu,     ButtonLights.LightButtonGamesMenu],
    [Button.ButtonCallAttendant, ButtonLights.LightButtonCallAttendant],
    [Button.ButtonHelp,          ButtonLights.LightButtonHelp],
    [Button.ButtonBet1,          ButtonLights.LightButtonBet1],
    [Button.ButtonBet2,          ButtonLights.LightButtonBet2],
    [Button.ButtonBet3,          ButtonLights.LightButtonBet3],
    [Button.ButtonBet4,          ButtonLights.LightButtonBet4],
    [Button.ButtonBet5,          ButtonLights.LightButtonBet5],
    [Button.ButtonBetUp,         ButtonLights.LightButtonBetUp],
    [Button.ButtonBetDown,       ButtonLights.LightButtonBetDown],
    [Button.ButtonLinesNext,     ButtonLights.LightButtonLinesNext],
]);

export class IOManager
{
    protected iosetup: IOSetup;

    public Connected: boolean = false;
    public ConnectionMessage: string = null;


    protected inputMap: Map<number, InputMap> = new Map<number, InputMap>();
    protected inputStates: InputState[] = [];


    protected inputState: Map<InputFunction, boolean> = new Map<InputFunction, boolean>();

    protected buttonState: Map<Button, ButtonState> = new Map<Button, ButtonState>();

    protected outputMap: Map<OutputFunction, OutputMap> = new Map<OutputFunction, OutputMap>();
    //protected outputStates: OutputState[] = [];
    protected outputStates: Map<OutputFunction, OutputState> = new Map<OutputFunction, OutputState>();


    protected outputs: OutputState[] = null;

    protected enableButtonsDelay: number = -1;

    protected buttonChangeHandlers: Map<string, ButtonChangedHandler> = new Map<string, ButtonChangedHandler>();    
    public AddButonChangeHandler(id: string, handler: ButtonChangedHandler)
    {
        if (this.buttonChangeHandlers.has(id))
        {
            throw new Error(`Button change handler with id ${id} already exists`);
        }
        this.buttonChangeHandlers.set(id, handler);
    }

    protected lightChangeHandlers: Map<string, LightChangeHandler> = new Map<string, LightChangeHandler>();
    public AddLightchangeHandler(id: string, handler: LightChangeHandler)
    {
        if (this.lightChangeHandlers.has(id))
        {
            throw new Error(`Light change handler with id ${id} already exists`);
        }

        this.lightChangeHandlers.set(id, handler);
    }


    protected inputsChangeHandlers: Map<string, InputsChangedHandler> = new Map<string, InputsChangedHandler>();
    public AddInputsChangeHandler(id: string, handler: InputsChangedHandler)
    {
        if (this.inputsChangeHandlers.has(id))
        {
            throw new Error(`Inputs change handler with id ${id} already exists`);
        }

        this.inputsChangeHandlers.set(id, handler);
    }

    public RemoveInputsChangeHandler(id: string)
    {
        this.inputsChangeHandlers.delete(id);
    }

    protected outputsChangeHandlers: Map<string, OutputsChangedHandler> = new Map<string, OutputsChangedHandler>();
    public AddOutputsChangeHandler(id: string, handler: OutputsChangedHandler)
    {
        if (this.outputsChangeHandlers.has(id))
        {
            throw new Error(`Outputs change handler with id ${id} already exists`);
        }

        this.outputsChangeHandlers.set(id, handler);
    }

    public RemoveOutputsChangeHandler(id: string)
    {
        this.outputsChangeHandlers.delete(id);
    }


    public constructor()
    {
        this.SetAllLightsCommon(OutputState.Off);
    }

    public SetIOSetup(iosetup: IOSetup): void
    {
        this.iosetup = iosetup;
        
        this.inputMap.clear();
        this.outputMap.clear();

        if (this.iosetup?.IOMapping)
        {
            this.iosetup.IOMapping.InputMap.forEach(m => this.inputMap.set(m.Pin, m as any as InputMap));
            this.iosetup.IOMapping.OutputMap.forEach(m => this.outputMap.set(m.Func, m));
        }

        if (this.iosetup.BoardParams?.NumOutputs)
        {
            let newOutputs: OutputState[] = new Array<OutputState>(this.iosetup.BoardParams.NumOutputs).fill(OutputState.Off);
            
            // copy old states
            (this.outputs ?? []).filter((s, i) => i < newOutputs.length).forEach((o, i) => newOutputs[i] = o);
            this.outputs = newOutputs;
        }
        else
        {
            this.outputs = [];
        }

        this.OutputsChanged();
        this.ReportOutputs();
    }

    public get IOSetup(): IOSetup
    {
        return this.iosetup;
    }

    public get Inputs(): InputState[]
    {
        return this.inputStates;
    }

    public get Outputs(): OutputState[]
    {
        return this.outputs;
    }

    // public EnableOnlyButtons(buttons: InputFunction[]): void
    // {
        
    // }

    // public DisableAllButtons(): void
    // {

    // }


    public EnableDisableButtons(buttonState: SetButtonState[])
    {
        buttonState.forEach(bs => {
            this.buttonState.set(bs.button, bs);

            let outputState: OutputState = bs.light;
            if (!outputState)
            {
                outputState = bs.enabled ? OutputState.On : OutputState.Off;
            }

            let bl: ButtonLight = buttonLightMap.get(bs.button);
            if (bl)
            {
                this.outputStates.set(bl as OutputFunction, bs.light);
            }
        });

        this.OutputsChanged();
        this.ReportOutputs();
    }

    protected CommonDisableAllButtons()
    {
        Object.values(Button).forEach(b => {
            this.buttonState.set(b, {
                button: b,
                enabled: false,
            });

            let bl: ButtonLight = buttonLightMap.get(b);
            if (bl)
            {
                this.outputStates.set(bl as OutputFunction, OutputState.Off);
            }
        });
    }

    protected CommonEnableAllButtons()
    {
        Object.values(Button).forEach(b => {
            this.buttonState.set(b, {
                button: b,
                enabled: true,
            });

            let bl: ButtonLight = buttonLightMap.get(b);
            if (bl)
            {
                this.outputStates.set(bl as OutputFunction, OutputState.On);
            }
        });
    }

    public DisableAllButtons()
    {
        this.CommonDisableAllButtons();
        this.OutputsChanged();
        this.ReportOutputs();
    }

    public EnableOnlyButtons(buttons: {button: Button, light?: OutputState}[])
    {
        this.CommonDisableAllButtons();
        buttons.forEach(b => {
            this.buttonState.set(b.button, {
                button: b.button,
                enabled: true,
            });

            let outputState: OutputState = b.light ?? OutputState.On;

            let bl: ButtonLight = buttonLightMap.get(b.button);
            if (bl)
            {
                this.outputStates.set(bl as OutputFunction, outputState);
            }
        });

        this.OutputsChanged();
        this.ReportOutputs();
    }

    public EnableAllButtons(buttons: {button: Button, light?: OutputState}[] = null)
    {
        this.CommonEnableAllButtons();

        Object.values(buttons ?? []).forEach(b => {
            let outputState: OutputState = b.light ?? OutputState.On;
            let l: ButtonLight = buttonLightMap.get(b.button);
            if (l)
            {
                this.outputStates.set(l as OutputFunction, outputState);
            }
        });

        this.OutputsChanged();
        this.ReportOutputs();
    }

    public FakeInput(inputFunction: InputFunction, high: boolean)
    {
        let spinButtonInputPin = this.IOSetup?.IOMapping?.InputMap?.find(i => i.Func == InputFunction.ButtonSpin)?.Pin;
        let newInputStates = [...this.Inputs];

        newInputStates[spinButtonInputPin] = high ? InputState.RisingEdge : InputState.FallingEdge;

        this.UpdateInputs(newInputStates);
    }

    public SetInput(index: number, state: InputState)
    {
        if (this.inputStates.length == 0)
        {
            let maxInputPin = this.iosetup.IOMapping.InputMap.reduce((max, m) => Math.max(max, m.Pin), 0);
            this.inputStates = new Array<InputState>(maxInputPin + 1).fill(InputState.Low);
        }

        if (index < 0 || index >= this.inputStates.length)
        {
            console.log(`Input index ${index} out of range, must be 0 <= index < ${this.inputStates.length}`);
            return;
        }

        let newInputStates = this.inputStates.map((s): InputState => {
            if (s == InputState.RisingEdge)
                return InputState.High;
            else if (s == InputState.FallingEdge)
                return InputState.Low;
            else
                return s;
        });

        newInputStates[index] = state;
        this.UpdateInputs(newInputStates);
    }


    public UpdateInputs(inputStates: InputState[])
    {
        this.inputStates = inputStates;

        this.inputsChangeHandlers.forEach(handler => handler(inputStates));

        for (let i = 0; i < inputStates.length; i++)
        {
            const map = this.inputMap.get(i);
            if (map && map.Type == InputType.Button)
            {
                if (inputStates[i] == InputState.RisingEdge || inputStates[i] == InputState.FallingEdge)
                {
                    let pressed: boolean = inputStates[i] == InputState.RisingEdge;

                    if (map.Polarity == InputPolarity.Reversed)
                    {
                        pressed = !pressed;
                    }

                    this.CheckButton(map.Func, pressed);
                }
            }
        }
    }

    public UpdateButton(button: Button, pressed: boolean)
    {
        this.CheckButton(button, pressed);
    }

    protected CheckButton(button: InputFunction, pressed: boolean)
    {
        if (this.inputState.has(button) || this.inputState.get(button) != pressed)
        {
            this.inputState.set(button as Button, pressed);
            this.buttonChangeHandlers.forEach(handler => handler(button as Button, pressed));
        }
        else
        {
            // already pressed
        }
    }


    // only set given lights, and don't touch others
    public UpdateLights(lights: {light: Light, state: OutputState}[])
    {
        lights.forEach(l => this.outputStates.set(l.light as OutputFunction, l.state));
        this.OutputsChanged();
        this.ReportOutputs();
    }

    // turn off all lights, and set given lights
    public SetOnlyLights(lights: {light: Light, state: OutputState}[])
    {
        this.SetAllLightsCommon(OutputState.Off);
        lights.forEach(l => this.outputStates.set(l.light as OutputFunction, l.state));
        this.OutputsChanged();
        this.ReportOutputs();
    }

    public SetLights(lights: {light: Light, state: OutputState}[])
    {
        // keep lights whatever they are before applying new states
        lights.forEach(l => this.outputStates.set(l.light as OutputFunction, l.state));
        this.OutputsChanged();
        this.ReportOutputs();
    }

    public SetAllLights(state: OutputState)
    {
        this.SetAllLightsCommon(state);
        this.OutputsChanged();
        this.ReportOutputs();
    }

    protected SetAllLightsCommon(state: OutputState)
    {
        Object.keys(ButtonLights).forEach((l) => {
            this.outputStates.set(l as OutputFunction, state);
        });
    }

    public SetOutput(output: number, state: OutputState)
    {
        if (output >= 0 && output < (this.outputs?.length ?? 0))
        {
            this.outputs[output] = state;
        }
        else
        {
            // output out of range, must be 0 <= output < this.iosetup.BoardParams.NumOutputs
            console.log(`output ${output} out of range, must be 0 <= output < ${this.outputs?.length ?? 0}`);
        }

        this.ReportOutputs();
    }

    public SetOutputs(states: OutputState[])
    {
        this.outputs = states;
        this.ReportOutputs();
    }

    // convert output functions to output pins and notify ioboard to set new output states
    protected OutputsChanged()
    {
        this.outputsChangeHandlers.forEach(handler => handler(this.outputs));
        //console.log(`Lights changed: ${[...this.outputStates.keys()].map(k => k + ": " + this.outputStates.get(k)).join(", ")}`);

        //if ((this.iosetup?.BoardParams?.NumOutputs ?? 0) > 0)
        //{
            //let outputs: OutputState[] = new Array(this.iosetup.BoardParams.NumOutputs).fill(OutputState.Off);

            this.outputStates.forEach((outputState, func) => {
                let map = this.outputMap.get(func);
                if (map && map.Pin < (this.outputs?.length ?? 0))
                {
                    this.outputs[map.Pin] = outputState;
                }
            });
        //}
    }

    protected ReportOutputs()
    {
        this.lightChangeHandlers.forEach(handler => handler(this.outputs));
    }
}
